import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'app-page-not-found',
	templateUrl: 'page-not-found.html',
})
export class PageNotFoundComponent {
}
